namespace GeniuzPOS.Administration {
    export class PsConfigTypeColumns {
        static columnsKey = 'Administration.PsConfigType';
    }
}
